import { makeStyles } from "tss-react/mui"
import { Typography } from "@mui/material"
import { LocalizedStrict } from "../../../../../../modules/localization/components/AppLocalized"

const useStyles = makeStyles()((theme) => ({
    text: {
        fontStyle: "italic",
        padding: ".375rem 0",
    },
    placeholder: {
        color: theme.palette.text.secondary,
    },
    error: {
        color: "#d32f2f",
    },
}))

type MeetingServicesPlaceholderProps = {
    isError?: boolean
}

export function MeetingServicesPlaceholder({ isError = false }: MeetingServicesPlaceholderProps) {
    const { classes, cx } = useStyles()

    return (
        <LocalizedStrict id="create-order-order-summary-meeting-services-empty">
            <Typography
                variant={isError ? "caption" : "body1"}
                className={cx(classes.text, isError ? classes.error : classes.placeholder)}
            >
                No items added yet
            </Typography>
        </LocalizedStrict>
    )
}
